export const GET_PERSONNELS = "GET_PERSONNELS";
export const GET_PERSONNELS_SUCCESS = "GET_PERSONNELS_SUCCESS";
export const GET_PERSONNELS_FAILURE = "GET_PERSONNELS_FAILURE";

export const GET_SINGLE_PERSONNEL = "GET_SINGLE_PERSONNEL";
export const GET_SINGLE_PERSONNEL_SUCCESS = "GET_SINGLE_PERSONNEL_SUCCESS";
export const GET_SINGLE_PERSONNEL_FAILURE = "GET_SINGLE_PERSONNEL_FAILURE";

export const ADD_PERSONNEL = "ADD_PERSONNEL";
export const ADD_PERSONNEL_SUCCESS = "ADD_PERSONNEL_SUCCESS";
export const ADD_PERSONNEL_FAILURE = "ADD_PERSONNEL_FAILURE";

export const EDIT_PERSONNEL = "EDIT_PERSONNEL";
export const EDIT_PERSONNEL_SUCCESS = "EDIT_PERSONNEL_SUCCESS";
export const EDIT_PERSONNEL_FAILURE = "EDIT_PERSONNEL_FAILURE";

export const DELETE_PERSONNEL = "DELETE_PERSONNEL";
export const DELETE_PERSONNEL_SUCCESS = "DELETE_PERSONNEL_SUCCESS";
export const DELETE_PERSONNEL_FAILURE = "DELETE_PERSONNEL_FAILURE";

export const CHANGE_AVAILABILITY_STATUS = "CHANGE_AVAILABILITY_STATUS";
export const CHANGE_AVAILABILITY_STATUS_SUCCESS =
  "CHANGE_AVAILABILITY_STATUS_SUCCESS";
export const CHANGE_AVAILABILITY_STATUS_FAILURE =
  "CHANGE_AVAILABILITY_STATUS_FAILURE";
